module.exports = __webpack_public_path__ + "img/674032bd54c9e4dd83d45a56d1986beb.png";